export function decodeHtmlEntities(text = '') {
  var _doc$documentElement$;
  const doc = new DOMParser().parseFromString(text, 'text/html');
  return (_doc$documentElement$ = doc.documentElement.textContent) !== null && _doc$documentElement$ !== void 0 ? _doc$documentElement$ : text;
}